import { render, staticRenderFns } from "./_review.vue?vue&type=template&id=4b8137a2&lang=pug&"
import script from "./_review.vue?vue&type=script&lang=js&"
export * from "./_review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports